import { cookie } from '../cookie/cookie';
import { QueryString } from '@libs/utils/url/url.interfaces';
import { parseQuery } from '@libs/utils/url/url';

// Copy from Trip-planner

interface AffiliateCookieData {
    AffiliateId?: string;
    ClientId?: string;
}

enum AffiliateCookieProperties {
    AffiliateId = 'AffiliateId',
    ClientId = 'ClientId',
}

enum Cookies {
    AffiliateCookie = 'AffiliateCookie',
}

export function getAffiliateCookieData():
    | {
          affiliateCookie: string;
          affiliateCookieParams: AffiliateCookieData;
      }
    | undefined {
    const affiliateCookie = cookie.get(Cookies.AffiliateCookie);
    const affiliateCookieData: AffiliateCookieData = {};

    if (!affiliateCookie) {
        return;
    }

    const affiliateCookieParams = getCookieParams(
        affiliateCookie,
        AffiliateCookieProperties.AffiliateId,
        AffiliateCookieProperties.ClientId
    );
    affiliateCookieData.AffiliateId = affiliateCookieParams['AffiliateId'];
    affiliateCookieData.ClientId = affiliateCookieParams['ClientId'];

    return {
        affiliateCookie,
        affiliateCookieParams,
    };
}

function getCookieParams(
    cookie: string,
    ...cookieParams: string[]
): Record<string, string | undefined> {
    const parsedCookie: QueryString = parseQuery(cookie);

    return cookieParams.reduce(
        (cookieDictionary, param) => {
            cookieDictionary[param] = getParsedCookieParam(param, parsedCookie);
            return cookieDictionary;
        },
        {} as Record<string, string | undefined>
    );
}

function getParsedCookieParam(
    cookieValue: string,
    parsedCookie: QueryString
): string | undefined {
    const cookieProperty = parsedCookie[cookieValue];
    if (cookieProperty) {
        return cookieProperty[0];
    }
}
